import {
  getECardex,
  getTakingOver,
  getBedScore,
  getClinicObservation,
  getGlucose,
  getFall,
  getFallTwo,
  getPediatric_fall,
  getGCS,
  getPediatric_GCS,
  getFourScore,
  getHospitalization,
  getMedication,
  getNeeds,
  getOutHospital,
  getPathology,
  getRadiology,
  getSafety,
  getNRS,
  getFLACC,
  getCNPS,
  getBDI,
  getBAI,
  getMMSE,
  getCIST,
  getOperation,
  getAnesthesia,
  getTransfusion,
  getDialysis,
  getEmergency,
  getChildbirth,
  getHomeCare,
  getFallConfirm,
  getHospitalConfirm,
  getColonoscopy,
  getUpperEndoscopy,
  getNonSalary,
  getMedicalRecords,
  getDNR,
  getDNA,
  getMentalNursing,
  getCheckListRoom,
  getFFI,
  getLEFS,
  getSTarT,
  getKOOS,
  getNDI,
  getBedScoreTwo,
  getKPCS,
  getTransfusionAgree,
  getSuppressor,
  getCentralVenous,
  getCPR,
  getNursingProcess,
  getKPCS_ICU,
  getIntubation,
  getCRRT,
  getDNRTwo,
  getKPCSC,
  getKPCSN,
  getKPCS_GW,
  getKPCS_NICU,
  getKDSQ_P,
  getKDSQ_C,
  getK_CPAT,
  getPAINAD_K,
  getPAINAD_K_none,
  getClinicObservationICU,
  getIntakeOutput,
  getIntubationAgree,
  getDietList,
  getFallThree,
  getMSE,
  getBloodDispensing,
  getNews2,
  getBedSoreFour,
  getBedScoreThree,
  getSBAR,
  getSBAR2,
  getSBAR3,
  getNursingNeed,
  getAdmAndDischarge,
  getSelfDischarge,
  getInfection,
  getEtcRecord,
  getRestraint,
  getDebriefing,
  getECMO,
  getMinor,
  getConsentForSurgery,
  getMaturity,
} from 'apis/survey';
import useNotification from 'hooks/useNotification';
import { findKeyValueToObj, findKeyValueToObjNoParse } from 'utils/convert';

import {
  initialECardex,
  initialTakingOver,
  initialOutHospitalSurvey,
  initialHospitalizationSurvey,
  initialMedicationSurvey,
  initialRadiology,
  initialPathology,
  initialBedScore,
  initialBedScoreTwo,
  initialFall,
  initialFallTwo,
  initialNeeds,
  initialPediatric_fall,
  initialGCS,
  initialPediatric_GCS,
  initialFourScore,
  initialClinicalObservation,
  initialGlucose,
  initialSafety,
  initialNRS,
  initialFLACC,
  initialCNPS,
  initialMentalNursing,
  initialBDI,
  initialBAI,
  initialMMSE,
  initialCIST,
  initialOperation,
  initialAnesthesia,
  initialTransfusion,
  initialDialysis,
  initialEmergency,
  initialChildbirth,
  initialHomeCare,
  initialHospitalConfirm,
  initialFallConfirm,
  initialColonoscopy,
  initialUpperEndoscopy,
  initialNonSalary,
  initialMedicalRecords,
  initialDNR,
  initialDNA,
  initialCoreNursingSkillVideo,
  initialCoreNursingSkillVideoExemple,
  initialCheckListRoom,
  initialFFI,
  initialLEFS,
  initialSTarTBack,
  initialKOOS,
  initialNDI,
  initialKPCS,
  initialTransfusionAgree,
  initialDietList,
  initialSuppressor,
  initialCRRT,
  initialIntubation,
  initialCentralVenous,
  initialCPR,
  initialNursingProcess,
  initialKPCS_ICU,
  initialDNRTwo,
  initialKPCSC,
  initialKPCSN,
  initialKPCS_GW,
  initialKPCSC_NICU,
  initialKDSQ_P,
  initialKDSQ_C,
  initialK_CPAT,
  initialPAINAD_K,
  initialPAINAD_K_none,
  initialClinicalObservationICU,
  initialIntakeOutput,
  initialIntubationAgree,
  initialFallThree,
  initialMSE,
  initialBloodDispensing,
  initialNEWS2,
  initialBedScoreFour,
  initialBedScoreThree,
  initialSBAR,
  initialSBAR2,
  initialSBAR3,
  initialNursingNeed,
  initialAdmissionAndDischarge,
  initialSelfDischarge,
  initialInfection,
  initialEtcRecord,
  initialRestraint,
  initialSimulationPlan,
  initialProcessRecord,
  initialPersonalInfoAgreement,
  initialDebriefing,
  initialSubmitAssignment,
  initialECMO,
  initialMinor,
  initialConsentForSurgery,
  initialMaturity,
} from '../initialStates';
import { MENU } from '../type';

interface Props {
  user_id: number;
  setDefaultValues: (v: any) => void;
}

const useDefaultValues = ({ setDefaultValues, user_id }: Props) => {
  const { onFail } = useNotification();

  const convertDataToStates = (data: any, states: any) => {
    const values = { ...states };
    const keys = Object.keys(states);

    for (let key of keys) {
      const getValue = data[key];

      if (typeof getValue !== 'object' || Array.isArray(getValue)) {
        values[key] = getValue;
      } else if (getValue) {
        try {
          values[key] = findKeyValueToObj(getValue, Object.keys(getValue));
        } catch {
          values[key] = findKeyValueToObjNoParse(
            getValue,
            Object.keys(getValue)
          );
        }
      }
    }
    setDefaultValues(values);
  };

  const onGetDefaultValues = (patient_id: number, type: string) => {
    switch (type) {
      case MENU.E_CARDEX:
        getECardex({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, ecardex_survey } = data;
            convertDataToStates(
              { update_at, ...ecardex_survey },
              initialECardex
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.TAKING_OVER:
        getTakingOver({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, take_over_survey } = data;
            convertDataToStates(
              { update_at, ...take_over_survey },
              initialTakingOver
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.SBAR:
        getSBAR({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, sbar1_survey } = data;
            convertDataToStates(
              { update_at: sbar1_survey?.updateAt, ...sbar1_survey },
              initialSBAR
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.SBAR2:
        getSBAR2({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, sbar2_survey } = data;
            convertDataToStates(
              {
                update_at,

                situation1: sbar2_survey
                  ? JSON.parse(sbar2_survey.situation1)
                  : {},
                situation1_input1: sbar2_survey?.situation1_input1,
                situation2: sbar2_survey
                  ? JSON.parse(sbar2_survey.situation2)
                  : {},
                situation2_input: sbar2_survey?.situation2_input,

                background_infection: sbar2_survey
                  ? JSON.parse(sbar2_survey.background_infection)
                  : {},
                background_allergy: sbar2_survey
                  ? JSON.parse(sbar2_survey.background_allergy)
                  : {},
                background_allergy_input1:
                  sbar2_survey?.background_allergy_input1,
                background_allergy_input2:
                  sbar2_survey?.background_allergy_input2,
                background_input: sbar2_survey?.background_input,

                assessment: sbar2_survey
                  ? JSON.parse(sbar2_survey.assessment)
                  : {},
                assessment_input1: sbar2_survey?.assessment_input1,

                recommendation1_input1: sbar2_survey?.recommendation1_input1,
                recommendation1: sbar2_survey
                  ? JSON.parse(sbar2_survey.recommendation1)
                  : {},
                recommendation2_monitor_o2: sbar2_survey
                  ? JSON.parse(sbar2_survey.recommendation2_monitor_o2)
                  : {},
                recommendation2_monitor_o2_input:
                  sbar2_survey?.recommendation2_monitor_o2_input,
                recommendation2_monitor_patients: sbar2_survey
                  ? JSON.parse(sbar2_survey.recommendation2_monitor_patients)
                  : {},
                recommendation2_monitor_etc_input:
                  sbar2_survey?.recommendation2_monitor_etc_input,
                recommendation2_etc_input:
                  sbar2_survey?.recommendation2_etc_input,

                sending: sbar2_survey?.sending,
                subject: sbar2_survey?.subject,
                takeover: sbar2_survey?.takeover,
                consignee: sbar2_survey?.consignee,
              },
              initialSBAR2
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.SBAR3:
        getSBAR3({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, sbar3_survey } = data;
            convertDataToStates(
              {
                update_at,
                situation_input: sbar3_survey?.situation_input,

                background_pmh: sbar3_survey
                  ? JSON.parse(sbar3_survey.background_pmh)
                  : {},
                background_tests: sbar3_survey
                  ? JSON.parse(sbar3_survey.background_tests)
                  : {},
                background_tests_input: sbar3_survey?.background_tests_input,

                assessment_contact: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_contact)
                  : {},
                assessment_need: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_need)
                  : {},
                assessment_extras: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_extras)
                  : {},
                assessment_iv_input: sbar3_survey?.assessment_iv_input,
                assessment_iv_date: sbar3_survey?.assessment_iv_date,
                assessment_iv_rs: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_iv_rs)
                  : {},
                assessment_iv_site: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_iv_site)
                  : {},
                assessment_iv_site_input:
                  sbar3_survey?.assessment_iv_site_input,
                assessment_iv_central: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_iv_central)
                  : {},

                assessment_drips_ivf: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_drips_ivf)
                  : {},
                assessment_drips_ivf_input:
                  sbar3_survey?.assessment_drips_ivf_input,
                assessment_drips_iv_input:
                  sbar3_survey?.assessment_drips_iv_input,
                assessment_drips_iv_date:
                  sbar3_survey?.assessment_drips_iv_date,
                assessment_drips_drips: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_drips_drips)
                  : {},
                assessment_neuro: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_neuro)
                  : {},
                assessment_neuro_input: sbar3_survey?.assessment_neuro_input,
                assessment_neuro_activity: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_neuro_activity)
                  : {},

                assessment_pain_input1: sbar3_survey?.assessment_pain_input1,
                assessment_pain_input2: sbar3_survey?.assessment_pain_input2,
                assessment_pain_input3: sbar3_survey?.assessment_pain_input3,
                assessment_pain_input4: sbar3_survey?.assessment_pain_input4,

                assessment_res: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_res)
                  : {},
                assessment_res_input: sbar3_survey?.assessment_res_input,
                assessment_res_input_trach:
                  sbar3_survey?.assessment_res_input_trach,
                assessment_res_input_sound: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_res_input_sound)
                  : {},
                assessment_res_input_treat: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_res_input_treat)
                  : {},
                assessment_res_input_cough: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_res_input_cough)
                  : {},

                assessment_vs_hr: sbar3_survey?.assessment_vs_hr,
                assessment_vs_temp: sbar3_survey?.assessment_vs_temp,
                assessment_vs_bp: sbar3_survey?.assessment_vs_bp,
                assessment_vs_rr: sbar3_survey?.assessment_vs_rr,
                assessment_vs_o2: sbar3_survey?.assessment_vs_o2,

                assessment_cardio: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_cardio)
                  : {},
                assessment_cardio_edema: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_cardio_edema)
                  : {},
                assessment_cardio_pulse: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_cardio_pulse)
                  : {},
                assessment_vte: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_vte)
                  : {},
                assessment_gastro_diet: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_gastro_diet)
                  : {},
                assessment_gastro_symptom: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_gastro_symptom)
                  : {},
                assessment_gastro_tube: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_gastro_tube)
                  : {},
                assessment_genitour: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_genitour)
                  : {},
                assessment_genitour_dialysis: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_genitour_dialysis)
                  : {},
                assessment_muscul_weak: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_muscul_weak)
                  : {},
                assessment_muscul_nuber: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_muscul_nuber)
                  : {},
                assessment_skin_input: sbar3_survey?.assessment_skin_input,
                assessment_bg: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_bg)
                  : {},
                assessment_bg_input: sbar3_survey?.assessment_bg_input,
                assessment_bg_ac_b: sbar3_survey?.assessment_bg_ac_b,
                assessment_bg_ac_l: sbar3_survey?.assessment_bg_ac_l,
                assessment_bg_ac_d: sbar3_survey?.assessment_bg_ac_d,
                assessment_bg_hs: sbar3_survey?.assessment_bg_hs,

                assessment_drains: sbar3_survey
                  ? JSON.parse(sbar3_survey.assessment_drains)
                  : {},
                assessment_drains_input: sbar3_survey?.assessment_drains_input,

                assessment_lap_0: sbar3_survey?.assessment_lap_0,
                assessment_lap_1: sbar3_survey?.assessment_lap_1,
                assessment_lap_2: sbar3_survey?.assessment_lap_2,
                assessment_lap_3: sbar3_survey?.assessment_lap_3,
                assessment_lap_4: sbar3_survey?.assessment_lap_4,
                assessment_lap_5: sbar3_survey?.assessment_lap_5,
                assessment_lap_6: sbar3_survey?.assessment_lap_6,
                assessment_lap_7: sbar3_survey?.assessment_lap_7,
                assessment_lap_8: sbar3_survey?.assessment_lap_8,
                assessment_lap_9: sbar3_survey?.assessment_lap_9,
                assessment_lap_10: sbar3_survey?.assessment_lap_10,
                assessment_lap_11: sbar3_survey?.assessment_lap_11,
                assessment_lap_12: sbar3_survey?.assessment_lap_12,
                assessment_lap_13: sbar3_survey?.assessment_lap_13,

                recommendation_schedule: sbar3_survey
                  ? JSON.parse(sbar3_survey.recommendation_schedule)
                  : {},
                recommendation_consults: sbar3_survey
                  ? JSON.parse(sbar3_survey.recommendation_consults)
                  : {},
                recommendation_discharge: sbar3_survey
                  ? JSON.parse(sbar3_survey.recommendation_discharge)
                  : {},
              },
              initialSBAR3
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.HOSPITALIZATION:
        getHospitalization({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, hospitalization_survey } = data;

            convertDataToStates(
              { update_at, ...hospitalization_survey },
              initialHospitalizationSurvey
            );
          })

          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.OUT_HOSPITAL:
        getOutHospital({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, out_hospital_survey } = data;
            convertDataToStates(
              { update_at, ...out_hospital_survey },
              initialOutHospitalSurvey
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.MEDICATION:
        getMedication({ user_id, patient_id })
          .then(({ data }) => {
            convertDataToStates(data, initialMedicationSurvey);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.RADIOLOGY:
        getRadiology({ user_id, patient_id })
          .then(({ data }) => {
            convertDataToStates(data, initialRadiology);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.PATHOLOGY:
        getPathology({ user_id, patient_id })
          .then(({ data }) => {
            convertDataToStates(data, initialPathology);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.CLINICAL_OBSERVATION:
        getClinicObservation({ user_id, patient_id })
          .then(({ data }) => {
            const { vital_sign, io_check } = data;
            const m_data = {
              ...data,
              vital_sign: JSON.parse(vital_sign),
              io_check: JSON.parse(io_check),
            };
            convertDataToStates(m_data, initialClinicalObservation);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.CLINICAL_OBSERVATION_ICU:
        getClinicObservationICU({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, catholic_clinical_observation } = data;

            convertDataToStates(
              { update_at, ...catholic_clinical_observation },
              initialClinicalObservationICU
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.IORECORD:
        getIntakeOutput({ user_id, patient_id })
          .then(({ data }) => {
            convertDataToStates(data, initialIntakeOutput);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.GLUCOSE:
        getGlucose({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, blood_sugar_survey } = data;
            convertDataToStates(
              { update_at, ...blood_sugar_survey },
              initialGlucose
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.NEWS2:
        getNews2({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, news2_survey } = data;
            convertDataToStates({ update_at, ...news2_survey }, initialNEWS2);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.BEDSORES:
        getBedScore({ user_id, patient_id })
          .then(({ data }) => {
            const { contents } = data;
            const m_data = { ...data, contents: JSON.parse(contents) };
            convertDataToStates(m_data, initialBedScore);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.BEDSORESTWO:
        getBedScoreTwo({ user_id, patient_id })
          .then(({ data }) => {
            const { contents } = data;
            const m_data = { ...data, contents: JSON.parse(contents) };
            convertDataToStates(m_data, initialBedScoreTwo);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.BEDSORESTHREE:
        getBedScoreThree({ user_id, patient_id })
          .then(({ data }) => {
            const { contents } = data;
            const m_data = { ...data, contents: JSON.parse(contents) };
            convertDataToStates(m_data, initialBedScoreThree);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.BEDSORESFOUR:
        getBedSoreFour({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, bedsore4_survey } = data;
            convertDataToStates(
              {
                update_at,
                gender: bedsore4_survey?.gender,
                age: bedsore4_survey?.age,
                weight: bedsore4_survey?.weight,
                incontinence: bedsore4_survey?.incontinence,
                mobility: bedsore4_survey?.mobility,
                appetite: bedsore4_survey?.appetite,

                skin00: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.skin00)
                  : false,
                skin01: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.skin01)
                  : false,
                skin02: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.skin02)
                  : false,
                skin03: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.skin03)
                  : false,
                skin04: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.skin04)
                  : false,

                special_risk00: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.special_risk00)
                  : false,
                special_risk01: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.special_risk01)
                  : false,
                special_risk02: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.special_risk02)
                  : false,
                special_risk03: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.special_risk03)
                  : false,
                special_risk04: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.special_risk04)
                  : false,
                special_risk05: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.special_risk05)
                  : false,
                special_risk06: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.special_risk06)
                  : false,
                special_risk07: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.special_risk07)
                  : false,
                special_risk08: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.special_risk08)
                  : false,
                special_risk09: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.special_risk09)
                  : false,
                special_risk010: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.special_risk010)
                  : false,
                special_risk011: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.special_risk011)
                  : false,
                special_risk012: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.special_risk012)
                  : false,
                special_risk013: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.special_risk013)
                  : false,
                special_risk014: bedsore4_survey
                  ? JSON.parse(bedsore4_survey?.special_risk014)
                  : false,
              },
              initialBedScoreFour
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.NEEDS:
        getNeeds({ user_id, patient_id })
          .then(({ data }) => {
            const { body_status, disease_status } = data;
            const m_data = {
              ...data,
              body_status: JSON.parse(body_status),
              disease_status: JSON.parse(disease_status),
            };
            convertDataToStates(m_data, initialNeeds);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.FALL:
        getFall({ user_id, patient_id })
          .then(({ data }) => {
            const { contents } = data;
            const m_data = { ...data, contents: JSON.parse(contents) };
            convertDataToStates(m_data, initialFall);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.FALLTWO:
        getFallTwo({ user_id, patient_id })
          .then(({ data }) => {
            const { contents } = data;
            const m_data = { ...data, contents: JSON.parse(contents) };
            convertDataToStates(m_data, initialFallTwo);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.FALLTHREE:
        getFallThree({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, fall3_survey } = data;
            convertDataToStates(
              {
                update_at,
                assessment: fall3_survey
                  ? JSON.parse(fall3_survey?.assessment)
                  : {},
                age: fall3_survey?.age,
                fall: fall3_survey?.fall,
                evacuation: fall3_survey?.evacuation,
                drug: fall3_survey?.drug,
                device: fall3_survey?.device,

                mobility00: fall3_survey
                  ? JSON.parse(fall3_survey?.mobility00)
                  : false,
                mobility01: fall3_survey
                  ? JSON.parse(fall3_survey?.mobility01)
                  : false,
                mobility02: fall3_survey
                  ? JSON.parse(fall3_survey?.mobility02)
                  : false,

                recognition00: fall3_survey
                  ? JSON.parse(fall3_survey?.recognition00)
                  : false,
                recognition01: fall3_survey
                  ? JSON.parse(fall3_survey?.recognition01)
                  : false,
                recognition02: fall3_survey
                  ? JSON.parse(fall3_survey?.recognition02)
                  : false,
              },
              initialFallThree
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.FALLSCALE:
        getPediatric_fall({ user_id, patient_id })
          .then(({ data }) => {
            const { contents } = data;
            const m_data = { ...data, contents: JSON.parse(contents) };
            convertDataToStates(m_data, initialPediatric_fall);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.GCS:
        getGCS({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, gcs_survey } = data;
            convertDataToStates({ update_at, ...gcs_survey }, initialGCS);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.Pediatric_GCS:
        getPediatric_GCS({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, pediatric_gcs_survey } = data;
            convertDataToStates(
              { update_at, ...pediatric_gcs_survey },
              initialPediatric_GCS
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.FourScore:
        getFourScore({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, four_score_survey } = data;
            convertDataToStates(
              { update_at, ...four_score_survey },
              initialFourScore
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.Maturity:
        getMaturity({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, new_ballard_scale } = data;
            convertDataToStates(
              { update_at, ...new_ballard_scale },
              initialMaturity
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.SAFETY:
        getSafety({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, safety_survey } = data;
            convertDataToStates(
              {
                update_at,
                accident_consequences_details:
                  safety_survey?.accident_consequences_details,
                event_classification: safety_survey?.event_classification,
                falling_type: {
                  ...safety_survey?.falling_type,
                  patient_risk_factors: safety_survey
                    ? JSON.parse(
                        safety_survey.falling_type?.patient_risk_factors
                      )
                    : [],
                  patient_risk_factors_two: safety_survey
                    ? JSON.parse(
                        safety_survey.falling_type?.patient_risk_factors_two
                      )
                    : [],
                },
                medication_type: safety_survey?.medication_type,
                other_type: safety_survey?.other_type,
                other_type_etc: safety_survey?.other_type_etc,
                accident_detail: safety_survey?.accident_detail,
                accident_handling: safety_survey?.accident_handling,
                accident_result: safety_survey?.accident_result,
              },
              initialSafety
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.INFECTION:
        getInfection({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, infection_survey } = data;
            convertDataToStates(
              {
                update_at,
                info_name: infection_survey?.info_name,
                info_no: infection_survey?.info_no,
                info_contact: infection_survey?.info_contact,
                info_date: infection_survey?.info_date,
                info_department: infection_survey?.info_department,
                info_job: infection_survey?.info_job,
                info_gender: infection_survey?.info_gender,
                info_pregnancy: infection_survey?.info_pregnancy,
                info_pregnancy_input: infection_survey?.info_pregnancy_input,

                infection_matters: infection_survey
                  ? JSON.parse(infection_survey.infection_matters)
                  : {},
                infection_date: infection_survey?.infection_date,
                infection_time: infection_survey?.infection_time,
                infection_place: infection_survey?.infection_place,

                infection_left: infection_survey
                  ? JSON.parse(infection_survey.infection_left)
                  : {},
                infection_right: infection_survey
                  ? JSON.parse(infection_survey.infection_right)
                  : {},
                infection_situation: infection_survey
                  ? JSON.parse(infection_survey.infection_situation)
                  : {},
                infection_cause: infection_survey
                  ? JSON.parse(infection_survey.infection_cause)
                  : {},
                infection_cause_input: infection_survey?.infection_cause_input,

                wear_gloves1: infection_survey?.wear_gloves1,
                wear_gloves2: infection_survey?.wear_gloves2,
                wear_gloves_none: infection_survey
                  ? JSON.parse(infection_survey.wear_gloves_none)
                  : {},

                infection_state: infection_survey
                  ? JSON.parse(infection_survey.infection_state)
                  : {},
                infection_state_input: infection_survey?.infection_state_input,

                infection_after: infection_survey
                  ? JSON.parse(infection_survey.infection_after)
                  : {},

                infection_after_input: infection_survey?.infection_after_input,
                infection_after_medi: infection_survey?.infection_after_medi,
                infection_after_test: infection_survey?.infection_after_test,

                ...infection_survey,
              },
              initialInfection
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.NRS:
        getNRS({ user_id, patient_id })
          .then(({ data }) => {
            convertDataToStates(data, initialNRS);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다', e));
        break;
      case MENU.FLACC:
        getFLACC({ user_id, patient_id })
          .then(({ data }) => {
            convertDataToStates(data, initialFLACC);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다', e));
        break;
      case MENU.CNPS:
        getCNPS({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, cnps_survey } = data;
            convertDataToStates({ update_at, ...cnps_survey }, initialCNPS);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.FFI:
        getFFI({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, ffi_survey } = data;
            convertDataToStates({ update_at, ...ffi_survey }, initialFFI);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다', e));
        break;
      case MENU.KOOS:
        getKOOS({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, contents } = data;
            convertDataToStates({ update_at, ...contents }, initialKOOS);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.LEFS:
        getLEFS({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, contents } = data;
            convertDataToStates({ update_at, ...contents }, initialLEFS);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.NDI:
        getNDI({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, contents } = data;
            convertDataToStates({ update_at, ...contents }, initialNDI);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.STarT_BacknScreening:
        getSTarT({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, contents } = data;
            convertDataToStates({ update_at, ...contents }, initialSTarTBack);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.K_CPAT:
        getK_CPAT({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, contents } = data;

            convertDataToStates(
              {
                update_at,
                no_1: contents?.no_1,

                no_2_a_1: contents?.no_2_a_1,
                no_2_a_2: contents?.no_2_a_2,
                no_2_a_3: contents?.no_2_a_3,
                no_2_a_4: contents?.no_2_a_4,
                no_2_a_5: contents?.no_2_a_5,

                no_2_b_1: contents?.no_2_b_1,
                no_2_b_2: contents?.no_2_b_2,
                no_2_b_3: contents?.no_2_b_3,
                no_2_b_4: contents?.no_2_b_4,
                no_2_b_5: contents?.no_2_b_5,
                no_2_b_6: contents?.no_2_b_6,

                no_2_c_1: contents?.no_2_c_1,
                no_2_c_2: contents?.no_2_c_2,
                no_2_c_3: contents?.no_2_c_3,
                no_2_c_4: contents?.no_2_c_4,
                no_2_c_5: contents?.no_2_c_5,

                no2_d_input: contents?.no2_d_input,
                no2_d: contents?.no2_d,

                no3: contents?.no3,

                no4: contents ? JSON.parse(contents.no4) : {},

                no5_1: contents?.no5_1,
                no5_2: contents?.no5_2,
                no5_3: contents?.no5_3,
                no5_4: contents?.no5_4,
                no5_5: contents?.no5_5,
                no5_6: contents?.no5_6,
                no5_7: contents?.no5_7,
                no5_8: contents?.no5_8,
              },
              initialK_CPAT
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다', e));
        break;
      case MENU.PAINAD_K:
        getPAINAD_K({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, contents } = data;

            convertDataToStates(
              {
                update_at,
                respiration01: contents?.respiration01,
                shout01: contents?.shout01,
                face01: contents?.face01,
                body01: contents?.body01,
                mind01: contents?.mind01,
                nrs01: contents?.nrs01,
                face_algo01: contents?.face_algo01,
                sight_algo01: contents?.sight_algo01,
                shout_algo01: contents?.shout_algo01,
                body_algo01: contents?.body_algo01,
                action_algo01: contents?.action_algo01,

                respiration02: contents?.respiration02,
                shout02: contents?.shout02,
                face02: contents?.face02,
                body02: contents?.body02,
                mind02: contents?.mind02,
                nrs02: contents?.nrs02,
                face_algo02: contents?.face_algo02,
                sight_algo02: contents?.sight_algo02,
                shout_algo02: contents?.shout_algo02,
                body_algo02: contents?.body_algo02,
                action_algo02: contents?.action_algo02,

                respiration03: contents?.respiration03,
                shout03: contents?.shout03,
                face03: contents?.face03,
                body03: contents?.body03,
                mind03: contents?.mind03,
                nrs03: contents?.nrs03,
                face_algo03: contents?.face_algo03,
                sight_algo03: contents?.sight_algo03,
                shout_algo03: contents?.shout_algo03,
                body_algo03: contents?.body_algo03,
                action_algo03: contents?.action_algo03,
              },
              initialPAINAD_K
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다', e));
        break;
      case MENU.PAINAD_K_non:
        getPAINAD_K_none({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, contents } = data;

            convertDataToStates(
              {
                update_at,
                respiration01: contents?.respiration01,
                shout01: contents?.shout01,
                face01: contents?.face01,
                body01: contents?.body01,
                mind01: contents?.mind01,
                face_cpot01: contents?.face_cpot01,
                body_cpot01: contents?.body_cpot01,
                voice_cpot01: contents?.voice_cpot01,
                muscle_cpot01: contents?.muscle_cpot01,
                face_algo01: contents?.face_algo01,
                sight_algo01: contents?.sight_algo01,
                shout_algo01: contents?.shout_algo01,
                body_algo01: contents?.body_algo01,
                action_algo01: contents?.action_algo01,

                respiration02: contents?.respiration02,
                shout02: contents?.shout02,
                face02: contents?.face02,
                body02: contents?.body02,
                mind02: contents?.mind02,
                face_cpot02: contents?.face_cpot02,
                body_cpot02: contents?.body_cpot02,
                voice_cpot02: contents?.voice_cpot02,
                muscle_cpot02: contents?.muscle_cpot02,
                face_algo02: contents?.face_algo02,
                sight_algo02: contents?.sight_algo02,
                shout_algo02: contents?.shout_algo02,
                body_algo02: contents?.body_algo02,
                action_algo02: contents?.action_algo02,

                respiration03: contents?.respiration03,
                shout03: contents?.shout03,
                face03: contents?.face03,
                body03: contents?.body03,
                mind03: contents?.mind03,
                face_cpot03: contents?.face_cpot03,
                body_cpot03: contents?.body_cpot03,
                voice_cpot03: contents?.voice_cpot03,
                muscle_cpot03: contents?.muscle_cpot03,
                face_algo03: contents?.face_algo03,
                sight_algo03: contents?.sight_algo03,
                shout_algo03: contents?.shout_algo03,
                body_algo03: contents?.body_algo03,
                action_algo03: contents?.action_algo03,
              },
              initialPAINAD_K_none
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다', e));
        break;
      case MENU.MENTAL_NURSING:
        getMentalNursing({ user_id, patient_id })
          .then(({ data }) => {
            convertDataToStates(data, initialMentalNursing);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.MSE:
        getMSE({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, mse_survey } = data;
            convertDataToStates({ update_at, ...mse_survey }, initialMSE);
          })

          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.BDI:
        getBDI({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, bdi_survey } = data;
            convertDataToStates({ update_at, ...bdi_survey }, initialBDI);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.BAI:
        getBAI({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, bai_survey } = data;
            convertDataToStates({ update_at, ...bai_survey }, initialBAI);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.MMSE:
        getMMSE({ user_id, patient_id })
          .then(({ data }) => {
            convertDataToStates(data, initialMMSE);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.CIST:
        getCIST({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, cist_survey } = data;
            convertDataToStates(
              {
                update_at,
                orientation1: cist_survey?.orientation1,
                orientation2: cist_survey?.orientation2,
                orientation3: cist_survey?.orientation3,
                orientation4: cist_survey?.orientation4,
                orientation5: cist_survey?.orientation5,
                memory1: cist_survey ? JSON.parse(cist_survey.memory1) : {},
                memory2: cist_survey ? JSON.parse(cist_survey.memory2) : {},
                attention1: cist_survey?.attention1,
                attention2: cist_survey?.attention2,
                attention3: cist_survey?.attention3,
                visual_spatial_ability: cist_survey?.visual_spatial_ability,
                executive_function1_1: cist_survey?.executive_function1_1,
                executive_function1_2: cist_survey?.executive_function1_2,
                executive_function1_3: cist_survey?.executive_function1_3,
                memory3: cist_survey ? JSON.parse(cist_survey.memory3) : {},
                memory4: cist_survey ? JSON.parse(cist_survey.memory4) : {},
                language_function1: cist_survey?.language_function1,
                language_function2: cist_survey?.language_function2,
                language_function3: cist_survey?.language_function3,
                language_function4: cist_survey?.language_function4,
                executive_function2: cist_survey?.executive_function2,
              },
              initialCIST
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;

      case MENU.KDSQ_P:
        getKDSQ_P({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, kdsqp_survey } = data;
            convertDataToStates({ update_at, ...kdsqp_survey }, initialKDSQ_P);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.KDSQ_C:
        getKDSQ_C({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, kdsqc_survey } = data;
            convertDataToStates({ update_at, ...kdsqc_survey }, initialKDSQ_C);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.OPERATION:
        getOperation({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, surgical_survey } = data;
            convertDataToStates(
              { update_at, ...surgical_survey },
              initialOperation
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.ANESTHESIA:
        getAnesthesia({ user_id, patient_id })
          .then(({ data }) => {
            convertDataToStates(data, initialAnesthesia);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.TRANSFUSION:
        getTransfusion({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, transfusion_survey } = data;
            const transfusionInfo =
              transfusion_survey?.transfusion_information || {};

            // 간단한 파싱 함수
            const parseJson = (str: string, defaultVal: any = {}) => {
              try {
                return typeof str === 'string' ? JSON.parse(str) : str;
              } catch {
                return defaultVal;
              }
            };

            convertDataToStates(
              {
                update_at,
                ...transfusionInfo,
                irradiation: transfusionInfo.irradiation
                  ? parseJson(transfusionInfo.irradiation, {
                      has_irradiation: null,
                      content: '',
                    })
                  : { has_irradiation: null, content: '' },
                filtering: transfusionInfo.filtering
                  ? parseJson(transfusionInfo.filtering, {
                      is_compatible: null,
                      content: '',
                    })
                  : { is_compatible: null, content: '' },
                transfusion_record: transfusion_survey?.transfusion_record,
              },
              initialTransfusion
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;

      case MENU.BLOODDISCHARGE:
        getBloodDispensing({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, blood_dispensing_survey } = data;
            convertDataToStates(
              {
                update_at,
                ...blood_dispensing_survey,
              },
              initialBloodDispensing
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.RESTRAINT:
        getRestraint({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, medical_restraint_survey } = data;
            convertDataToStates(
              {
                update_at,
                ...medical_restraint_survey,
              },
              initialRestraint
            );
          })

          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.INTUBATION:
        getIntubation({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, line_survey } = data;
            convertDataToStates(
              {
                update_at,
                cline_information: line_survey?.cline_information,
                aline_information: line_survey?.aline_information,
                foley_information: line_survey?.foley_information,
                avf_information: line_survey?.avf_information,
                hd_information: line_survey?.hd_information,
                etube_information: line_survey?.etube_information,
              },
              initialIntubation
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.DIALYSIS:
        getDialysis({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, hemodialysis_survey } = data;
            convertDataToStates(
              {
                update_at,
                ...hemodialysis_survey?.dialysis_information,
                ...hemodialysis_survey?.weight_information,
                dialysis_db: hemodialysis_survey?.dialysis_db,
                crrt: hemodialysis_survey?.crrt,
                additional_information:
                  hemodialysis_survey?.additional_information,
              },
              initialDialysis
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.CPR:
        getCPR({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, catholic_cpr_survey } = data;
            convertDataToStates(
              {
                update_at,
                find_place: catholic_cpr_survey?.find_place,
                cpr_place: catholic_cpr_survey?.cpr_place,
                cpr_leader: catholic_cpr_survey?.cpr_leader,
                writer: catholic_cpr_survey?.writer,
                find_date: catholic_cpr_survey?.find_date,
                find_time: catholic_cpr_survey?.find_time,
                terminate_reason: catholic_cpr_survey?.terminate_reason,
                clinical_observation: catholic_cpr_survey?.clinical_observation,
                treatment: catholic_cpr_survey?.treatment,
                intubation: catholic_cpr_survey?.intubation,
                medication: catholic_cpr_survey?.medication,
                test: catholic_cpr_survey?.test,
              },
              initialCPR
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.EMERGENCY:
        getEmergency({ user_id, patient_id }).then(({ data }) => {
          const { update_at, emergency_register_survey } = data;
          convertDataToStates(
            { update_at, ...emergency_register_survey },
            initialEmergency
          );
        });
        break;
      case MENU.CHILDBIRTH:
        getChildbirth({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, delivery_survey } = data;
            convertDataToStates(
              { update_at, ...delivery_survey },
              initialChildbirth
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.HOME_CARE:
        getHomeCare({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, homecare_survey } = data;
            convertDataToStates(
              { update_at, ...homecare_survey },
              initialHomeCare
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.ECMO:
        getECMO({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, ecmo_info_survey } = data;
            convertDataToStates(
              {
                update_at,
                treatment_place: ecmo_info_survey?.treatment_place,
                treatment_reason: {
                  ...ecmo_info_survey?.treatment_reason,
                  indications: ecmo_info_survey
                    ? JSON.parse(ecmo_info_survey.treatment_reason?.indications)
                    : [],
                  va_arrest: ecmo_info_survey
                    ? JSON.parse(ecmo_info_survey.treatment_reason?.va_arrest)
                    : [],
                  va_arrest_lvad: ecmo_info_survey
                    ? JSON.parse(
                        ecmo_info_survey.treatment_reason?.va_arrest_lvad
                      )
                    : [],
                },
                reason_vv_ecmo: ecmo_info_survey?.reason_vv_ecmo,
                summation: ecmo_info_survey?.summation,

                inhibition_check: ecmo_info_survey
                  ? JSON.parse(ecmo_info_survey?.inhibition_check)
                  : [],

                inhibition1: ecmo_info_survey?.inhibition1,
                inhibition2: ecmo_info_survey?.inhibition2,
                inhibition3: ecmo_info_survey?.inhibition3,
                inhibition4: ecmo_info_survey?.inhibition4,
                inhibition5: ecmo_info_survey?.inhibition5,
                inhibition6: ecmo_info_survey?.inhibition6,
                inhibition7: ecmo_info_survey?.inhibition7,
                inhibition8: ecmo_info_survey?.inhibition8,
                inhibition9: ecmo_info_survey?.inhibition9,
                inhibition10: ecmo_info_survey?.inhibition10,
                inhibition11: ecmo_info_survey?.inhibition11,

                special_reason: ecmo_info_survey?.special_reason,
              },
              initialECMO
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.ECMO:
        getSafety({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, safety_survey } = data;
            convertDataToStates(
              {
                update_at,
                accident_consequences_details:
                  safety_survey?.accident_consequences_details,
                event_classification: safety_survey?.event_classification,
                falling_type: {
                  ...safety_survey?.falling_type,
                  patient_risk_factors: safety_survey
                    ? JSON.parse(
                        safety_survey.falling_type?.patient_risk_factors
                      )
                    : [],
                  patient_risk_factors_two: safety_survey
                    ? JSON.parse(
                        safety_survey.falling_type?.patient_risk_factors_two
                      )
                    : [],
                },
                medication_type: safety_survey?.medication_type,
                other_type: safety_survey?.other_type,
                other_type_etc: safety_survey?.other_type_etc,
                accident_detail: safety_survey?.accident_detail,
                accident_handling: safety_survey?.accident_handling,
                accident_result: safety_survey?.accident_result,
              },
              initialSafety
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.KPCS:
        getKPCS({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, kpcs_survey } = data;
            convertDataToStates({ update_at, ...kpcs_survey }, initialKPCS);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.KPCSC:
        getKPCSC({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, kpcsc_survey } = data;
            convertDataToStates({ update_at, ...kpcsc_survey }, initialKPCSC);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.KPCSN:
        getKPCSN({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, kpcsn_survey } = data;
            convertDataToStates({ update_at, ...kpcsn_survey }, initialKPCSN);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.KPCS_GW:
        getKPCS_GW({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, kpcs_gw_survey } = data;
            convertDataToStates(
              { update_at, ...kpcs_gw_survey },
              initialKPCS_GW
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.KPCS_ICU:
        getKPCS_ICU({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, kpcs_icu_survey } = data;
            convertDataToStates(
              { update_at, ...kpcs_icu_survey },
              initialKPCS_ICU
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.KPCS_NICU:
        getKPCS_NICU({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, kpcs_nicu_survey } = data;
            convertDataToStates(
              { update_at, ...kpcs_nicu_survey },
              initialKPCSC_NICU
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.NURSING_NEED:
        getNursingNeed({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, nursing_needs_survey } = data;

            convertDataToStates(
              {
                update_at,
                no01_organization_name:
                  nursing_needs_survey?.no01_organization_name,
                no01_ward_code: nursing_needs_survey?.no01_ward_code,
                no01_date: nursing_needs_survey?.no01_date,
                no01_name: nursing_needs_survey?.no01_name,
                no01_dept: nursing_needs_survey?.no01_dept,
                no01_contact: nursing_needs_survey?.no01_contact,

                no02_02: nursing_needs_survey?.no02_02,
                no02_03: nursing_needs_survey?.no02_03,
                no02_04: nursing_needs_survey?.no02_04,
                no02_05: nursing_needs_survey?.no02_05,
                no02_06: nursing_needs_survey?.no02_06,
                no02_07: nursing_needs_survey?.no02_07,

                no03_01: nursing_needs_survey?.no03_01,
                no03_02: nursing_needs_survey?.no03_02,
                no03_03: nursing_needs_survey?.no03_03,
                no03_04: nursing_needs_survey?.no03_04,
                no03_05: nursing_needs_survey?.no03_05,
                no03_06: nursing_needs_survey?.no03_06,
                no03_07: nursing_needs_survey?.no03_07,
                no03_08: nursing_needs_survey?.no03_08,
                no03_09: nursing_needs_survey?.no03_09,
                no03_10: nursing_needs_survey?.no03_10,
                no03_11: nursing_needs_survey?.no03_11,
                no03_12: nursing_needs_survey?.no03_12,
                no03_13: nursing_needs_survey?.no03_13,
                no03_14: nursing_needs_survey?.no03_14,

                no04_01: nursing_needs_survey?.no04_01,
                no04_02: nursing_needs_survey?.no04_02,
                no04_03: nursing_needs_survey?.no04_03,
                no04_04: nursing_needs_survey?.no04_04,
                no04_05: nursing_needs_survey?.no04_05,
                no04_06: nursing_needs_survey?.no04_06,
                no04_07: nursing_needs_survey?.no04_07,

                no05_01: nursing_needs_survey?.no05_01,

                no06_01: nursing_needs_survey?.no06_01,
                no06_02: nursing_needs_survey?.no06_02,
              },
              initialNursingNeed
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.RADIOLOGYETC:
        getEtcRecord({ user_id, patient_id })
          .then(({ data }) => {
            convertDataToStates(data, initialEtcRecord);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.DIET_NUTRITION:
        getDietList({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, dietary_survey } = data;

            convertDataToStates(
              { update_at, ...dietary_survey },
              initialDietList
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.HOSPITAL_CONFIRM:
        getHospitalConfirm({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, hospital_confirm } = data;
            convertDataToStates(
              {
                update_at,
                nursing_care: hospital_confirm
                  ? JSON.parse(hospital_confirm.nursing_care)
                  : {},
                facilities_in: hospital_confirm
                  ? JSON.parse(hospital_confirm.facilities_in)
                  : {},
                facilities: hospital_confirm
                  ? JSON.parse(hospital_confirm.facilities)
                  : {},
                name: hospital_confirm?.name,
                relationship: hospital_confirm?.relationship,
                signature: hospital_confirm?.signature,
                date: hospital_confirm?.date,
                personnel_signature: hospital_confirm?.personnel_signature,
              },
              initialHospitalConfirm
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.ADMISSIN_AND_DISCHARGE:
        getAdmAndDischarge({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, adm_discharge } = data;
            convertDataToStates(
              {
                update_at,

                date: adm_discharge?.date,
                patient_name: adm_discharge?.patient_name,
                patient_sig: adm_discharge?.patient_sig,
                guardian_name: adm_discharge?.guardian_name,
                guardian_sig: adm_discharge?.guardian_sig,
                guardian_birth: adm_discharge?.guardian_birth,
                guardian_phone: adm_discharge?.guardian_phone,
              },
              initialAdmissionAndDischarge
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.SELF_DISCHARGE:
        getSelfDischarge({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, self_discharge } = data;
            convertDataToStates(
              {
                update_at,

                patient_relationship: self_discharge?.patient_relationship,
                patient_name: self_discharge?.patient_name,
                date: self_discharge?.date,
                consenter_relationship: self_discharge?.consenter_relationship,
                consenter_name: self_discharge?.consenter_name,
                consenter_sig: self_discharge?.consenter_sig,
                attestor_spot: self_discharge?.attestor_spot,
                attestor_name: self_discharge?.attestor_name,
                attestor_sig: self_discharge?.attestor_sig,
              },
              initialSelfDischarge
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.FALL_CONFIRM:
        getFallConfirm({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, fall_confirm } = data;
            convertDataToStates(
              {
                update_at,
                fall_education: fall_confirm
                  ? JSON.parse(fall_confirm.fall_education)
                  : {},
                signature: fall_confirm?.signature,
                date: fall_confirm?.date,
                personnel_signature: fall_confirm?.personnel_signature,
              },
              initialFallConfirm
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.TRANSFUSIONAGREEMENT:
        getTransfusionAgree({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, transfusion_confirmation } = data;
            convertDataToStates(
              {
                update_at,
                ...transfusion_confirmation,
              },
              initialTransfusionAgree
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;

      case MENU.CRRT_AGREEMENT:
        getCRRT({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, crrt_confirmation } = data;
            convertDataToStates(
              {
                update_at,

                no1_1: crrt_confirmation?.no1_1,
                no1_2: crrt_confirmation
                  ? JSON.parse(crrt_confirmation.no1_2)
                  : {},
                no1_3: crrt_confirmation?.no1_3,
                no2: crrt_confirmation?.no2,
                no3_1: crrt_confirmation
                  ? JSON.parse(crrt_confirmation.no3_1)
                  : {},

                date: crrt_confirmation?.date,
                relationship: crrt_confirmation?.relationship,
                name: crrt_confirmation?.name,
                sign: crrt_confirmation?.sign,
              },
              initialCRRT
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.CENTRALVENOUS:
        getCentralVenous({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, cvc_insertion_confirmation } = data;
            convertDataToStates(
              {
                update_at,
                no1: cvc_insertion_confirmation
                  ? JSON.parse(cvc_insertion_confirmation.no1)
                  : {},
                pt_bday: cvc_insertion_confirmation?.pt_bday,
                pt_contact: cvc_insertion_confirmation?.pt_contact,
                pt_name: cvc_insertion_confirmation?.pt_name,
                pt_sign: cvc_insertion_confirmation?.pt_sign,

                nok_bday: cvc_insertion_confirmation?.nok_bday,
                nok_contact: cvc_insertion_confirmation?.nok_contact,
                nok_name: cvc_insertion_confirmation?.nok_name,
                nok_sign: cvc_insertion_confirmation?.nok_sign,

                dr_name: cvc_insertion_confirmation?.dr_name,
                dr_sign: cvc_insertion_confirmation?.dr_sign,
              },
              initialCentralVenous
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.INTUBATIONAGREEMENT:
        getIntubationAgree({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, intubation_confirmation } = data;
            convertDataToStates(
              {
                update_at,
                ...intubation_confirmation,
              },
              initialIntubationAgree
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.COLONOSCOPY:
        getColonoscopy({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, colono_scopy_confirmation } = data;
            convertDataToStates(
              {
                update_at,
                ...colono_scopy_confirmation,
              },
              initialColonoscopy
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      // 여기
      case MENU.UPPER_ENDOSCOPY:
        getUpperEndoscopy({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, upper_endo_scopy_confirmation } = data;
            convertDataToStates(
              {
                update_at,
                ...upper_endo_scopy_confirmation,
              },
              initialUpperEndoscopy
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.SUPPRESSOR:
        getSuppressor({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, restraints_confirmation } = data;
            convertDataToStates(
              {
                update_at,
                ...restraints_confirmation,
              },
              initialSuppressor
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.NONSALARY:
        getNonSalary({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, uninsured_benefit_confirmation } = data;
            convertDataToStates(
              {
                update_at,
                ...uninsured_benefit_confirmation,
              },
              initialNonSalary
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.CONSENT_FOR_SURGERY:
        getConsentForSurgery({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, surgery_agreement } = data;
            convertDataToStates(
              {
                update_at,
                ...surgery_agreement,
              },
              initialConsentForSurgery
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.MEDICALRECORDS:
        getMedicalRecords({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, chart_confirmation } = data;
            convertDataToStates(
              {
                update_at,
                ...chart_confirmation,
              },
              initialMedicalRecords
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.DNR:
        getDNR({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, advance_directive_confirmation } = data;
            convertDataToStates(
              {
                update_at,
                ...advance_directive_confirmation,
              },
              initialDNR
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.DNRTWO:
        getDNRTwo({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, dnr_confirmation } = data;
            convertDataToStates(
              {
                update_at,
                ...dnr_confirmation,
              },
              initialDNRTwo
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.DNA:
        getDNA({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, gene_test_confirmation } = data;
            convertDataToStates(
              {
                update_at,
                ...gene_test_confirmation,
              },
              initialDNA
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.MINOR:
        getMinor({ user_id, patient_id })
          .then(({ data }) => {
            const { update_at, minor_consent } = data;
            convertDataToStates(
              {
                update_at,
                ...minor_consent,
              },
              initialMinor
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.NURSING_PROCESS:
        getNursingProcess({ user_id, patient_id })
          .then(({ data }) => {
            convertDataToStates(data, initialNursingProcess);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.DRUG_CALCULATOR:
        getFall({ user_id, patient_id })
          .then(({ data }) => {
            const { contents } = data;
            const m_data = { ...data, contents: JSON.parse(contents) };
            convertDataToStates(m_data, initialFall);
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.SUBMIT_ASSIGNMENT:
        convertDataToStates(initialSubmitAssignment, initialSubmitAssignment);
        break;
      case MENU.CORE_NURSING_SKILL_VIDEO:
        convertDataToStates(
          initialCoreNursingSkillVideo,
          initialCoreNursingSkillVideo
        );
        break;
      case MENU.CORE_NURSING_SKILL_VIDEO_EXEMPLE_ONE:
        convertDataToStates(
          initialCoreNursingSkillVideoExemple,
          initialCoreNursingSkillVideoExemple
        );
        break;
      case MENU.CORE_NURSING_SKILL_VIDEO_EXEMPLE_TWO:
        convertDataToStates(
          initialCoreNursingSkillVideoExemple,
          initialCoreNursingSkillVideoExemple
        );
        break;
      case MENU.CORE_NURSING_SKILL_VIDEO_EXEMPLE_THREE:
        convertDataToStates(
          initialCoreNursingSkillVideoExemple,
          initialCoreNursingSkillVideoExemple
        );
        break;
      case MENU.CORE_NURSING_SKILL_VIDEO_EXEMPLE_FOUR:
        convertDataToStates(
          initialCoreNursingSkillVideoExemple,
          initialCoreNursingSkillVideoExemple
        );
        break;
      case MENU.VOICE_EMR:
        convertDataToStates(
          initialCoreNursingSkillVideoExemple,
          initialCoreNursingSkillVideoExemple
        );
        break;
      case MENU.NURSE_CHECKLIST_ROOM:
        getCheckListRoom({ user_id, patient_id })
          .then(({ data }) => {
            const { nursing_check_list_ward, update_at } = data;

            convertDataToStates(
              { update_at, ...nursing_check_list_ward },
              initialCheckListRoom
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;

      case MENU.SIMUL_ACTIVITY_PLAN:
        convertDataToStates(initialSimulationPlan, initialSimulationPlan);
        break;
      case MENU.SIMUL_PROCESS_RECORD:
        convertDataToStates(initialProcessRecord, initialProcessRecord);
        break;
      case MENU.SIMUL_PERSONAL_INFO_AGREEMENT:
        convertDataToStates(
          initialPersonalInfoAgreement,
          initialPersonalInfoAgreement
        );
        break;
      case MENU.DEBRIEFING:
        getDebriefing({ user_id, patient_id })
          .then(({ data }) => {
            const { debriefing_survey } = data;
            convertDataToStates(
              { update_at: debriefing_survey?.updateAt, ...debriefing_survey },
              initialDebriefing
            );
          })
          .catch(e => onFail('알 수 없는 오류가 발생했습니다.', e));
        break;
      case MENU.PATIENT_LABEL_PRINTING:
        convertDataToStates(
          initialCoreNursingSkillVideoExemple,
          initialCoreNursingSkillVideoExemple
        );
        break;
      default:
        setDefaultValues(null);
        break;
    }
  };

  return { onGetDefaultValues };
};

export default useDefaultValues;
